var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.curvesReady)?_c('line3d',{attrs:{"map":_vm.map,"tb":_vm.tb,"lines":_vm.lines,"lineColor":_vm.lineColor,"lineWidth":_vm.lineWidth,"lineOpacity":_vm.lineOpacity}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }